import { Box, Drawer, Toolbar } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import GlobalContext from "../../contexts/globalcontext";
import {
    Home,
    Dashboard,
    CurrencyExchange,
    LightMode,
    Feed,
    OpenWith,
    DarkMode,
    PrecisionManufacturing,
    AccountBalanceWallet,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Badge,
} from "@mui/material";

const SideDrawer = () => {
    const {
        isDarkMode,
        setIsDarkMode,
        isDrawerOpen,
        setIsDrawerOpen,
        totalOrders,
    } = useContext(GlobalContext);
    const [drawerWidth, setDrawerWidth] = useState(0);
    const navigator = useNavigate();

    useEffect(() => {
        const dw = isDrawerOpen ? 220 : 60;
        setDrawerWidth(dw);
        // console.log("sidedrawer.js-useeffect");
    }, [isDrawerOpen]);

    return (
        <Box sx={{ display: "flex", whiteSpace: "nowrap" }}>
            <Drawer
                variant="persistent"
                open={true}
                anchor="left"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: drawerWidth,
                        boxSizing: "border-box",
                        overflow: "hidden",
                    },
                }}
            >
                <Toolbar />
                <Box sx={{ flexGrow: 1 }}>
                    <List dense sx={{ padding: 0, margin: 0 }}>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigator("/")}>
                                <ListItemIcon>
                                    <Home />
                                </ListItemIcon>
                                <ListItemText primary="Home" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => navigator("/dashboard")}
                            >
                                <ListItemIcon>
                                    <Dashboard />
                                </ListItemIcon>
                                <ListItemText primary="Dashboard" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => navigator("/tickers")}
                            >
                                <ListItemIcon>
                                    <CurrencyExchange />
                                </ListItemIcon>
                                <ListItemText primary="Tickers" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => navigator("/accounts")}
                            >
                                <ListItemIcon>
                                    <AccountBalanceWallet />
                                </ListItemIcon>
                                <ListItemText primary="Accounts Balance" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => navigator("/orders")}
                            >
                                <ListItemIcon>
                                    <Badge
                                        badgeContent={totalOrders}
                                        color="primary"
                                    >
                                        <Feed />
                                    </Badge>
                                </ListItemIcon>

                                <ListItemText primary="Orders" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigator("/bot")}>
                                <ListItemIcon>
                                    <PrecisionManufacturing />
                                </ListItemIcon>
                                <ListItemText primary="My Bots" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
                <Box>
                    <List dense sx={{ padding: 0, margin: 0 }}>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => setIsDarkMode(!isDarkMode)}
                            >
                                <ListItemIcon>
                                    {isDarkMode ? <LightMode /> : <DarkMode />}
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        isDarkMode ? "Light Mode" : "Dark Mode"
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => setIsDrawerOpen(!isDrawerOpen)}
                            >
                                <ListItemIcon>
                                    <OpenWith />
                                </ListItemIcon>
                                <ListItemText primary="Minimise Sidebar" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </Box>
    );
};

export default SideDrawer;
